import React, { useMemo } from 'react';
import { ThemeProvider, useTheme } from 'styled-components';
import { applyColoursV2 } from '@stylesheets/coloursV2Theme';

interface ProcessesThemeBoundaryProps {
  children: React.ReactNode;
}

// Page-scoped theme wrapper that swaps `theme.colors` for the May 2026
// `coloursV2` palette. Mount this only around Processes surfaces —
// `theme.colors.outlineVariant`, surface tokens, and the new
// `canvasPrimary` flow through to every descendant styled-component, so
// any non-Processes UI accidentally rendered inside the boundary would
// pick up V2 values too. Keep the boundary tight to the route element
// (and the editor-specific sidebar branches) for that reason.
const ProcessesThemeBoundary: React.FC<ProcessesThemeBoundaryProps> = ({
  children,
}) => {
  const baseTheme = useTheme();
  const themeV2 = useMemo(() => applyColoursV2(baseTheme), [baseTheme]);
  return <ThemeProvider theme={themeV2}>{children}</ThemeProvider>;
};

export default ProcessesThemeBoundary;
